import calculateScores from './calculateScores'
import checkFirstResponseIfNeeded from './checkFirstResponseIfNeeded'
import { ConditionalRule, ElementKind, sectionTypes } from './enums'
import isAssessmentAutoCollapsing from './isAssessmentAutoCollapsing'
import { ActionCardData, AssessmentData, QuestionData, SectionData } from './types'

/* This function adds some essential props to the ac json */
function enrichActionCardWithProps(ac: ActionCardData) {
  /* !!! Increase the UPD_VERSION value of this function if its logic was changed. Prev value is 13. 25.03.2026 changed to 14 */
  const UPD_VERSION = 14

  if (ac._isEnriched && ac._updateVersion === UPD_VERSION) return false

  ac.conditionalItems ??= []
  ac.conditionalQuestions ??= []
  ac.enabledSeparators ??= []
  ac.lastActiveSeparator ??= -1
  ac.touchedSeparators ??= []
  ac.commentedHeaders ??= []
  ac._isEnriched = true
  ac._updateVersion = UPD_VERSION

  let sepId = -1

  ac.sections?.forEach(sec => {
    if (!ac.hasPinnedSections && sec.isPinned) {
      ac.hasPinnedSections = true
    }

    const isSeparator = sec.type === sectionTypes.SEPARATOR

    if (isSeparator) {
      sepId = sec.id
    }

    if (sepId && !isSeparator) {
      sec.idOfSep = sepId
    }

    if (!Object.hasOwn(sec, 'isSectionMinimized')) {
      sec.isSectionMinimized ??= !sec.isOpened
    }

    /* Adding separator id to the places where it needs */
    handleElements(sec, sepId)
  })

  calculateScores(ac)

  return true
}

function handleElements(sec: SectionData, sepId: number) {
  sec.elements?.forEach(element => {
    ;(element as AssessmentData).responses?.forEach(resp => {
      resp.idOfSep = sepId
    })
    ;(element as QuestionData).idOfSep = sepId

    if (element.kind === ElementKind.ASSESSMENT) {
      handleAssessmentItem(sec, element as AssessmentData)
    }
  })
}

function handleAssessmentItem(sec: SectionData, item: AssessmentData) {
  const isAutoCollapse = isAssessmentAutoCollapsing(sec, item)

  item.isAutoCollapse ??= isAutoCollapse

  if (!isAutoCollapse) {
    item.checked = true

    if (item.tags?.length && !item.conditionRule) {
      item.conditionRule = ConditionalRule.OR
    }
  }

  checkFirstResponseIfNeeded(item)
}

export default enrichActionCardWithProps
